var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-toggle",
              rawName: "v-b-toggle.collapse-1",
              modifiers: { "collapse-1": true }
            }
          ],
          attrs: {
            "data-cy": "show-filters-button",
            variant: "primary",
            size: "sm"
          }
        },
        [_vm._v(" Filtros rápidos ")]
      ),
      _c(
        "b-collapse",
        { staticClass: "mt-2", attrs: { id: "collapse-1" } },
        [
          _c("b-card", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Institución remitente" } },
                    [
                      _c(
                        "b-input-group",
                        [
                          _c("b-form-input", {
                            attrs: {
                              "data-cy": "filter-sender",
                              placeholder: "Institución remitente",
                              name: "filterSender"
                            },
                            on: { input: _vm.onInput },
                            model: {
                              value: _vm.filters.sender,
                              callback: function($$v) {
                                _vm.$set(_vm.filters, "sender", $$v)
                              },
                              expression: "filters.sender"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Folio" } },
                    [
                      _c(
                        "b-input-group",
                        [
                          _c("b-form-input", {
                            attrs: {
                              placeholder: "Folio",
                              "data-cy": "filter-number",
                              name: "filterNumber"
                            },
                            on: { input: _vm.onInput },
                            model: {
                              value: _vm.filters.number,
                              callback: function($$v) {
                                _vm.$set(_vm.filters, "number", $$v)
                              },
                              expression: "filters.number"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Tipo de documento" } },
                    [
                      _c("v-select", {
                        class: { "v-select-danger": _vm.danger },
                        attrs: {
                          "data-cy": "select-doc-types-filters",
                          name: "type",
                          options: _vm.listOptions,
                          placeholder: "Tipo de documento",
                          reduce: function(option) {
                            return option.value
                          }
                        },
                        on: { input: _vm.onInput },
                        scopedSlots: _vm._u([
                          {
                            key: "spinner",
                            fn: function() {
                              return [
                                _vm.loading
                                  ? _c("b-spinner", {
                                      style: { opacity: _vm.loading ? 1 : 0 },
                                      attrs: { small: "", variant: "primary" }
                                    })
                                  : _vm._e()
                              ]
                            },
                            proxy: true
                          }
                        ]),
                        model: {
                          value: _vm.filters.type,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "type", $$v)
                          },
                          expression: "filters.type"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 text-right" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", "data-cy": "clear-filters-button" },
                      on: {
                        click: function($event) {
                          return _vm.clearFilters()
                        }
                      }
                    },
                    [_vm._v(" limpiar ")]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }